import imagesLandingPages from '../imagesLandingPages';

export default {
  softwaresText: {
    title: 'Why choose Python web development services?',
    subtitle:
      'Python has all that it takes to be the world’s best programming language. Our development team has successfully delivered powerful python-based applications for clients operating on various industries. We are sure that Python is all you are looking for!',
    description:
      'All the great software we create in Python is in accordance with a standardized workflow and Scrum methodology.',
    businessList: [
      {
        icon: imagesLandingPages.icon1SVG,
        title: 'It is secure',
        description: `Python is a top pick for web app development because it meets the 
      highest security standards. It is a stable and trusted technology even for companies 
      dealing with sensitive data.`
      },
      {
        icon: imagesLandingPages.python2SVG,
        title: 'It is well-established',
        description: `Thanks to open-source frameworks and multiple support libraries, Python
      makes developers more productive, and what’s important for you, it all speeds up the development process.`
      },
      {
        icon: imagesLandingPages.python3SVG,
        title: 'It is versatile',
        description: `Whether you want to develop a simple prototype or a complex application, Python covers it all, 
        no matter which industry you operate in.`
      },
      {
        icon: imagesLandingPages.djangoSVG,
        title: 'It’s ridiculously fast',
        description: `Python has Django–the best modern, secure, and powerful framework. What takes weeks to develop in other frameworks, goes down to days here.`
      }
    ]
  },
  headingText: {
    title:
      'Build powerful digital products in Python <br /> – the best backend language out there',
    description: `YouTube, Netflix, Spotify, and other global tech brands use Python for a variety of use cases, 
    ranging from rapid prototyping, quick MVP deliver, API development, to machine learning, and complex business 
    applications. Top choice for startups and SMEs, our developers make the most of it to meet your business needs.`,
    img: imagesLandingPages.pythonSVG
  },
  customColumnsText: {
    title: 'Python development services for your company',
    subtitle: 'Think about one of your ideas, Python is the way to build it.',
    list: `<ul>
        <li>MVP development</li>
        <li>Prototype development</li>
        <li>Application development</li>
      </ul>
      <ul>
        <li>Backend development</li>
        <li>Mitigation solutions</li>
        <li>Internet of Things (IoT)</li>
      </ul>
      <ul>
        <li>Machine Learning</li>
        <li>Data Science</li>
        <li>Support and maintenance</li>
      </ul>`
  },
  telecomSectionData: {
    title: 'Get top Python engineers for your project',
    description: [
      'Choosing the right technology partner for your business is not easy.',
      `At Ulam Labs, we assist you in each step of the software
      development, from the idea, through planning, across the
      development stage, till the release.`,
      `Our core specialty from the beginning was Python
      development. We provide a comprehensive range of services
      for end-to-end product development, including design,
      development, implementation and support. We build scalable
      and robust software solutions for enterprises and
      startups.`
    ],
    list: [
      'since 2012 on the market',
      '20+ successful projects',
      'Startups and SME oriented',
      'All range of industries: Fintech, Telco, E-commerce, and more...'
    ],
    btnText: "Let's work together"
  }
};
